/** Lightweight GraphQL request timing (browser). */

export type GraphqlPerfEntry = {
  id: number;
  operation: string;
  ms: number;
  ok: boolean;
  at: number;
  status?: number;
};

const MAX_ENTRIES = 40;

let seq = 0;
let entries = $state<GraphqlPerfEntry[]>([]);
let last = $state<GraphqlPerfEntry | null>(null);

function operationName(document: string): string {
  const match = document.match(/\b(query|mutation|subscription)\s+([A-Za-z0-9_]+)/);
  if (match?.[2]) return match[2];
  const anon = document.match(/\b(query|mutation|subscription)\b/);
  return anon?.[1] ?? "anonymous";
}

function push(entry: GraphqlPerfEntry) {
  last = entry;
  entries = [entry, ...entries].slice(0, MAX_ENTRIES);
  if (import.meta.env.DEV) {
    const tag = entry.ok ? "ok" : "err";
    console.debug(`[gql ${tag}] ${entry.operation} ${entry.ms.toFixed(0)}ms`, entry);
  }
}

export const graphqlPerf = {
  get last() {
    return last;
  },
  get entries() {
    return entries;
  },
  operationName,
  record(input: {
    document: string;
    ms: number;
    ok: boolean;
    status?: number;
  }) {
    push({
      id: ++seq,
      operation: operationName(input.document),
      ms: input.ms,
      ok: input.ok,
      at: Date.now(),
      status: input.status,
    });
  },
};
